import type { ApplePayBillingAddress } from '../types';
import { COUNTRY_CODE_US } from '../constants';

interface BillingData {
  cardholderName: string;
  billingAddress: ApplePayBillingAddress;
}

export function buildBillingData(
  billingContact?: ApplePayJS.ApplePayPaymentContact | null,
): BillingData {
  if (!billingContact) {
    return {
      cardholderName: '',
      billingAddress: {
        address: '',
        city: '',
        country: '',
        state: null,
        zip: '',
      },
    };
  }

  const {
    givenName,
    familyName,
    addressLines,
    locality,
    countryCode,
    administrativeArea,
    postalCode,
  } = billingContact;

  return {
    cardholderName: `${givenName ?? ''} ${familyName ?? ''}`.trim(),
    billingAddress: {
      address: (addressLines ?? [])
        .map(line => line.trim())
        .filter(Boolean)
        .join(', '),
      city: locality?.trim() ?? '',
      country: countryCode ?? '',
      state:
        countryCode === COUNTRY_CODE_US
          ? administrativeArea?.trim() ?? null
          : null,
      zip: postalCode?.trim() ?? '',
    },
  };
}
